// Use manual loading, so that we can trigger it with the turbo:load event
window.Prism = window.Prism || {}
Prism.manual = true

require("../plugins/prism.js")
